<template>
    <LayoutWithContainer v-if="$wait.is('load_events')">
        <div class="loading">
            <Spinner :height="40" :width="40"/>
        </div>
    </LayoutWithContainer>
    <LayoutWithContainer v-else>
        <template slot="header">
            <ContentHeader title="Documents">
                <template slot="actions">
                    <router-link :to="{ name: 'create-document' }" class="btn btn--primary" v-if="can('createInsightCategories')">
                        Add Document
                    </router-link>
                </template>
            </ContentHeader>
        </template>
        <div v-if="this.categories && this.categories.length > 0" class="grid grid--cards">
            <div class="col-xs-6" v-for="category in this.categories">
                <Card
                    :url="`/documents/category/${category.id}`"
                    :title="category.name"
                    :sub-title="category.description"
                    :img="category.image ? category.image.url : null"
                />
            </div>
        </div>
    </LayoutWithContainer>
</template>
<script>
    import { mapGetters } from 'vuex';
    import API from '@api';
    import LayoutWithContainer from '@layouts/LayoutWithContainer';
    import Card from '@components/Card/Card';
    import ContentHeader from '@components/Header/ContentHeader';
    import Spinner from '@components/Spinner';
    import SvgIcon from '@components/SvgIcon';

    export default {
        name: 'DocumentsRoot',
        components: {
            SvgIcon,
            Spinner,
            ContentHeader,
            LayoutWithContainer,
            Card
        },
        data() {
            return {
                categories: [],
                error: false,
            }
        },
        created() {
            this.getEvents();
        },
        methods: {
            async getEvents() {
                this.error = false;
                this.$wait.start('load_events');

                try {
                    this.categories = await API.getTopLevelInsightCategories();
                } catch(err) {
                    this.categories = []
                    this.error = true;
                    console.warn(err);
                } finally {
                    this.$wait.end('load_events');
                }
            },
        },
        computed: {
            ...mapGetters(['can']),
        },
    }
</script>
